module.exports = __webpack_public_path__ + "fonts/Simple-Line-Icons.78f07e2c.woff";